import type { FaireProductEntity } from "../../entity_types/product";

export const p_wkzqbgfyty: FaireProductEntity = {
  token: "p_wkzqbgfyty",
  type: "product",
  name: "Sweet Delicate Rhinestone Pearl Stud Earrings DPJE1466",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/c22ddf18b85f3dce0ffc8710483a829dff1642cbbac221207eeec0eb01e7feef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2b708efcea2c6b16d6a07980db338563b796cdc7b0d5edb4f8aa2a76d14bab0.jpeg",
    "https://cdn.faire.com/fastly/4e36e563522aa79216a5d58a813a92c71c179c847385a85653d1d9c89bddd132.jpeg",
    "https://cdn.faire.com/fastly/5b665761fa2fb819c5f5e73ac18d8456a51276d7412608c9e680ecd7926e8744.jpeg",
    "https://cdn.faire.com/fastly/6641a9008a499a81d429776e3006ec6b5f7efca98cc2bcff06b2116067181c16.jpeg",
    "https://cdn.faire.com/fastly/e450191af0bf4565a86ae2c4ca72047c2acd3c9b1aaaea673d90e70eec794b73.jpeg",
    "https://cdn.faire.com/fastly/09e3874cc20a54dfeb357b87902f77312f627b0ba376cb18afeb5f8c8d1569fb.jpeg",
    "https://cdn.faire.com/fastly/1a3b3057ec8270190c80d89e242ac1fb8b8311c1c58230bf66c58d7a122c24fe.jpeg",
    "https://cdn.faire.com/fastly/5f9638b0084fe41b8e39865957dc4479ccc8ebcf8ee0568dcdd6007facf6e832.jpeg",
    "https://cdn.faire.com/fastly/b38930524d5e9806c4a4a7b09d117ca00dd0fef80ad899be9fb6dc6fba34fc13.jpeg",
  ],
  priceDollars: 7,
  description:
    "Feature:\n * Sweet \n * Delicate \n * Rhinestone \n * Pearl \n\n Size:\n * 0.8 * 1.8cm\n\n Weigh:\n * 6.5g\n\n Material:\n * Alloys\n\n Package:\n * Package include 1 pair of earrings.\n\n Note: See picture labels (size and weight are hand-measured there will be a small error, specific in kind shall prevail, please note the size before purchase) ",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:41.216Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
